module.exports = __webpack_public_path__ + "img/banner_icon03.3b2680a5.jpg";